export const ROUTES = {
    TRANING_BATCHES: 'training-batches',
}